import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import Homepage from './pages/Homepage';
import AdminDashboard from './pages/admin/AdminDashboard';
import StudentDashboard from './pages/student/StudentDashboard';
import TeacherDashboard from './pages/teacher/TeacherDashboard';
import ParentDashboard from './pages/parent/ParentDashboard';
import LoginPage from './pages/LoginPage';
import ForgotPassword from './pages/ForgotPassword';
import SuperAdminBoardPage from './pages/superadmin/SuperAdminBoardPage';
import { ToastProvider } from './context/ToastContext';
import PremiumToast from './components/PremiumToast';

const App = () => {
  const { currentRole } = useSelector(state => state.user);

  return (
    <ToastProvider>
      <Router>
        {currentRole === null &&
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/Adminlogin" element={<LoginPage role="Admin" />} />
            <Route path="/Studentlogin" element={<LoginPage role="Student" />} />
            <Route path="/Teacherlogin" element={<LoginPage role="Teacher" />} />
            <Route path="/Parentlogin" element={<LoginPage role="Parent" />} />

            <Route path="/AdminForgotPassword" element={<ForgotPassword role="Admin" />} />
            <Route path="/StudentForgotPassword" element={<ForgotPassword role="Student" />} />
            <Route path="/TeacherForgotPassword" element={<ForgotPassword role="Teacher" />} />
            <Route path="/ParentForgotPassword" element={<ForgotPassword role="Parent" />} />

            <Route path="/superadminboard" element={<SuperAdminBoardPage />} />

            <Route path='*' element={<Navigate to="/" />} />

          </Routes>}

        {currentRole === "Admin" &&
          <>
            <AdminDashboard />
          </>
        }

        {currentRole === "Student" &&
          <>
            <StudentDashboard />
          </>
        }

        {currentRole === "Teacher" &&
          <>
            <TeacherDashboard />
          </>
        }

        {currentRole === "Parent" &&
          <>
            <ParentDashboard />
          </>
        }
      </Router>
      <PremiumToast />
    </ToastProvider>
  )
}

export default App